import React from 'react'
import { PermissionResponse, PermissionsResponse } from '../response/PermissionsResponseSchema';
import { Dropdown } from 'react-bootstrap';
import RequireAuth from '../../../auth/middleware/RequireAuth';

interface PermissionsTableProps {
    permissions: PermissionsResponse;
    onUpdate: (id: number) => void;
    onDelete: (id: number) => void;
}

const PermissionsTable: React.FC<PermissionsTableProps> = ({ permissions, onUpdate, onDelete }) => {
    return (
        <div className="table">
            <table className="table table-hover table-vcenter">
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Display Name</th>
                        <th>Group</th>
                        <th>created_at</th>
                        <th className="text-end">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {permissions.data.length === 0 && (
                        <tr>
                            <td colSpan={4} className="text-center">No permissions found</td>
                        </tr>
                    )}
                    {permissions.data.length > 0 && permissions.data.map((permission: PermissionResponse, index: number) => (
                        <React.Fragment key={index}>
                            <tr>
                                <td>{permission.name}</td>
                                <td>{permission.display_name}</td>
                                <td>{permission.group}</td>
                                <td>{permission.created_at}</td>
                                <td className="text-end">
                                    <Dropdown>
                                        <Dropdown.Toggle variant="default" id="dropdownMenuButton1">
                                            Actions
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu popperConfig={{ strategy: 'fixed' }}>
                                            {/* <Dropdown.Item href="#">View</Dropdown.Item> */}
                                            <RequireAuth requiredRoles={['dev']} requiredPermissions={['permission-update']} asComponent>
                                                <Dropdown.Item href="#" onClick={() => {
                                                    onUpdate(permission.id);
                                                }}>Edit</Dropdown.Item>
                                            </RequireAuth>
                                            <RequireAuth requiredRoles={['dev']} requiredPermissions={['permission-delete']} asComponent>
                                                <Dropdown.Item href="#" onClick={() => {
                                                    onDelete(permission.id);
                                                }}>
                                                    Remove
                                                </Dropdown.Item>
                                            </RequireAuth>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </td>
                            </tr>
                        </React.Fragment>
                    ))}
                </tbody>
            </table>
        </div>
    )
}

export default PermissionsTable